const module = { name: 'news/movieNews/app', exports: {} }; const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_carousel as fdCarousel } from 'require-global';



import { default as latestNewsWall } from 'swug-fdRequire-call:news/movieNews/latestNewsWall';



import { default as deferImages } from 'swug-fdRequire-call:global/jcarousel.deferImages';

function run() {
    checkDependencies(module.name, debugLog);
    fdCarousel.init('featured-carousel');
    fdCarousel.init('movie-carousel', { autoWidth: true, padding: { left: 0, right: 0 } });
    deferImages.init();
    latestNewsWall.init();
}
run();
export default module.exports;